<template>
  <v-row>
    <v-col cols="12">
      <!-- <v-tabs
        v-model="activeTab"
        class="home-tabs"
        grow
      >
        <v-tab>Empresas</v-tab>
        <v-tab>Empresas Registradas HOY!</v-tab>
        <v-tab>Empresas Favoritas!</v-tab>
      </v-tabs> -->
      <v-data-table
        :headers="headers"
        :items="items"
        :options.sync="options"
        :server-items-length="totalItems"
        :loading="loading"
        loading-text="Cargando..."
        class="elevation-1"
        item-key="id"
        :footer-props="footerOptions"
      >
        <template v-slot:top>
          <v-toolbar
            flat
            color="white"
          >
            <slot name="back" />
            <v-toolbar-title v-html="currentTitle" />
            <v-divider
              class="mx-4"
              inset
              vertical
            />
            <v-spacer />
            <v-text-field
              v-on:input="debounceInput"
              label="Buscar"
              single-line
              hide-details
            />
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <v-btn
                  v-on="on"
                  icon
                  class="mb-2 mr-2"
                  @click="refreshTable()"
                  :loading="loading"
                >
                  <v-icon>mdi-refresh</v-icon>
                </v-btn>
              </template>
              <span>Refrescar</span>
            </v-tooltip>
            <slot name="button">
              <v-btn
                v-if="can('crear_empresa')"
                :color="themeColor"
                class="white--text"
                @click="newItem()"
              >
                Nuevo Registro
              </v-btn>
            </slot>
          </v-toolbar>
        </template>
        <template v-slot:item.fel_id="{ item }">
          <v-switch
            :color="themeColor"
            :input-value="item.type === 1 || item.type === 2"
            :loading="toggleStatusFEL"
            @click.prevent="openModalStatusFEL(item)"
          />
        </template>
        <template v-slot:item.pac_id="{ item }">
          <v-switch
            :color="themeColor"
            :input-value="item.type === 2 || item.type === 3"
            :loading="toggleStatusPAC"
            @click.prevent="openModalStatusPAC(item)"
          />
        </template>
        <template v-slot:item.active="{ item }">
          <v-switch
            :color="themeColor"
            v-model="item.active"
            :loading="toggleStatus"
            @click.prevent="openModalStatus(item)"
          />
        </template>
        <template v-slot:item.action="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-icon
                :color="themeColor"
                class="white--text"
                @click="profile(item)"
                v-on="on"
              >
                mdi-account-search
              </v-icon>
            </template>
            <span>Perfil</span>
          </v-tooltip>
        </template>
        <template v-slot:no-data>
          <v-label>No se encontraron resultados.</v-label><br>
          <v-btn
            :color="themeColor"
            class="white--text"
            @click="reset"
          >
            Limpiar búsqueda
          </v-btn>
        </template>
      </v-data-table>
      <v-dialog
        v-model="dialogStatus"
        max-width="750"
      >
        <v-card>
          <v-card-title class="headline">
            ¿Estás seguro de que quieres cambiar el estado de este registro?
          </v-card-title>
          <v-card-actions>
            <v-spacer />
            <v-btn
              :color="themeColor"
              class="white--text"
              @click="dialogStatus = false"
            >
              Cancelar
            </v-btn>
            <v-btn
              :color="themeColor"
              class="white--text"
              :loading="toggleStatus"
              @click.prevent="toggleActive()"
            >
              Aceptar
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog
        v-model="dialogStatusFEL"
        max-width="600"
      >
        <v-card>
          <v-card-title class="headline">
            ¿Estás seguro de asociar este registro a FEL?
          </v-card-title>
          <v-card-text
            class="headline"
            color="red"
          >
            No podra deshacer esta acción.
          </v-card-text>
          <v-card-actions>
            <v-spacer />
            <v-btn
              :color="themeColor"
              class="white--text"
              @click="dialogStatusFEL = false"
            >
              Cancelar
            </v-btn>
            <v-btn
              :color="themeColor"
              class="white--text"
              :loading="toggleStatusFEL"
              @click.prevent="toggleActiveFEL()"
            >
              Aceptar
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog
        v-model="dialogStatusPAC"
        max-width="600"
      >
        <v-card>
          <v-card-title class="headline">
            ¿Estás seguro de asociar este registro a PAC?
          </v-card-title>
          <v-card-text
            class="headline"
            color="red"
          >
            No podra deshacer esta acción.
          </v-card-text>
          <v-card-actions>
            <v-spacer />
            <v-btn
              :color="themeColor"
              class="white--text"
              @click="dialogStatusPAC = false"
            >
              Cancelar
            </v-btn>
            <v-btn
              :color="themeColor"
              class="white--text"
              :loading="toggleStatusPAC"
              @click.prevent="toggleActivePAC()"
            >
              Aceptar
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-col>
  </v-row>
</template>

<script>
  import * as _ from 'underscore';
  import { mapGetters } from 'vuex';
  import Form from 'vform';

  export default {
    middleware: 'auth',
    metaInfo() {
      return { title: this.$t('enterprises') };
    },
    props: {
      action: { default: '' },
      message: { default: '' },
      apiURL: {},
      title: { default: 'Empresas' },
      refresh: { type: Boolean, default: false },
    },
    data: () => ({
      activeTab: 0,
      loading: false,
      dialogStatus: false,
      dialogStatusFEL: false,
      dialogStatusPAC: false,
      editedIndex: -1,
      options: {},
      search: '',
      items: [],
      totalItems: 0,
      footerOptions: { 'items-per-page-options': [10, 20, 30, 40, 50] },
      toggleShow: false,
      toggleStatus: false,
      toggleStatusFEL: false,
      toggleStatusPAC: false,
      itemsCorregimiento: [],
      name: '',
      form: new Form({
        ruc: '',
        name: '',
        email: '',
        dv: '',
        ruc_group_dv: '',
        cat_corregimiento_name: '',
        ruc_type: '',
        created_at: '',
        si: 'SI',
        no: 'NO',
        userws: '',
        email_address1: '',
      }),
      items_active: [
        { value: 0, text: 'INACTIVO' },
        { value: 1, text: 'ACTIVO' },
      ],
      items_type: [
        { value: 1, text: 'NATURAL' },
        { value: 2, text: 'JURÍDICO' },
      ],
      headers: [
        {
          text: 'Sucursal',
          value: 'branch_code',
          align: 'left',
          sortable: true,
        },
        {
          text: 'RUC',
          value: 'ruc',
          align: 'left',
          sortable: true,
        },
        {
          text: 'Razón Social',
          value: 'name',
          align: 'left',
          sortable: true,
        },
        {
          text: 'FEL',
          value: 'fel_id',
          align: 'left',
          sortable: true,
        },
        {
          text: 'PAC',
          value: 'pac_id',
          align: 'left',
          sortable: true,
        },
        {
          text: 'Estado',
          value: 'active',
          align: 'left',
          sortable: true,
        },
        {
          text: 'Acciones',
          value: 'action',
          sortable: false,
        },
      ],
    }),
    watch: {
      refresh() {
        this.refreshTable();
      },
      options: {
        handler() {
          this.getDataFromApi()
            .then((data) => {
              this.items = data.items;
              this.totalItems = data.total;
            });
        },
        deep: true,
      },
      search: {
        handler() {
          this.options.page = 1;
          this.getDataFromApi()
            .then((data) => {
              this.items = data.items;
              this.totalItems = data.total;
            });
        },
        deep: true,
      },
      activeTab() {
        this.options.page = 1;
        this.getDataFromApi()
          .then((data) => {
            this.items = data.items;
            this.totalItems = data.total;
          });
      },
    },
    mounted() {
      if (!this.can('activar_fel')) {
        this.headers.splice(this.headers.findIndex(({ text }) => text === 'FEL'), 1);
      }
      if (!this.can('activar_pac')) {
        this.headers.splice(this.headers.findIndex(({ text }) => text === 'PAC'), 1);
      }
      if (!this.can('cambiar_estado')) {
        this.headers.splice(this.headers.findIndex(({ text }) => text === 'Estado'), 1);
      }
    },
    computed: {
      ...mapGetters({
        user: 'auth/user',
        themeColor: 'theme/themeColor',
      }),
      currentTitle() {
        // if (this.activeTab === 1) {
        //   return 'Empresas Registradas HOY!';
        // }
        // if (this.activeTab === 2) {
        //   return 'Empresas Favoritas!';
        // }
        return this.title;
      },
      currentApiURL() {
        const baseURL = `/api/catalogs/dealers/${this.user.dealer_id}/enterprises`;
        // if (this.activeTab === 1) {
        //   return `${baseURL}/today`;
        // }
        // if (this.activeTab === 2) {
        //   return `${baseURL}/favorites`;
        // }
        return baseURL;
      },
    },
    methods: {
      debounceInput: _.debounce(function d(e) {
        this.search = e;
      }, 500),
      refreshTable() {
        this.getDataFromApi()
          .then((data) => {
            this.items = data.items;
            this.totalItems = data.total;
          });
      },
      getDataFromApi() {
        this.loading = true;

        return new Promise(async (resolve) => {
          const {
            sortBy,
            sortDesc,
            page,
            itemsPerPage,
          } = this.options;
          const response = await this.getItems(page, itemsPerPage, sortBy, sortDesc).then((response) => {
              const data = response.data.items;
              const { total } = response.data;
              return ({ data, total } || []);
          });
          const items = response.data;
          const { total } = response;

          setTimeout(() => {
            this.loading = false;
            resolve({
              items,
              total,
            });
          }, 1000);
        });
      },
      getItems(page, itemsPerPage, sortBy, sortDesc) {
        const url = `${this.currentApiURL}?currentPage=${page}&perPage=${itemsPerPage}&search=${this.search}&sortBy=${sortBy}&desc=${sortDesc}`;
        const promise = window.axios.get(url).then();
        return promise;
      },
      newItem() {
        this.$router.push({ name: 'enterprise.add' });
      },
      newItemMassive() {
        this.$router.push({ name: 'enterprises.import' });
      },
      profile(item) {
        this.$router.push({ name: 'enterprise.profileEnterprise', params: { id: item.id } });
      },
      reset() {
        this.search = '';
      },
      openModalStatus(item) {
          this.dialogStatus = true;
          this.item = item;
      },
      toggleActive() {
        this.toggleStatus = true;
        const url = `api/enterprises/${this.item.id}/toggle`;
        window.axios.post(url)
          .then((response) => {
            this.toggleStatus = false;
            this.action = 'toggleStatus';
            this.$store.dispatch('notifications/show', {
              message: response.data.message,
              type: response.data.type,
            });
            this.dialogStatus = false;
            this.item.active = !this.item.active;
          });
      },
      openModalStatusFEL(item) {
        if (item.type === null) {
          this.dialogStatusFEL = true;
          this.item = item;
        }
      },
      toggleActiveFEL() {
        this.toggleStatusFEL = true;
        const url = `${this.currentApiURL}/${this.item.id}/fel`;
        window.axios.post(url)
          .then((response) => {
            this.toggleStatusFEL = false;
            this.action = 'toggleStatusFEL';
            this.$store.dispatch('notifications/show', {
              message: response.data.message,
              type: response.data.type,
            });
            this.dialogStatusFEL = false;
            this.getDataFromApi()
            .then((data) => {
              this.items = data.items;
              this.totalItems = data.total;
            });
          });
      },
      openModalStatusPAC(item) {
        if (!item.type || item.type === 1) {
          this.dialogStatusPAC = true;
          this.item = item;
        }
      },
      toggleActivePAC() {
        this.toggleStatusPAC = true;
        const url = `${this.currentApiURL}/${this.item.id}/pac`;
        window.axios.post(url)
          .then((response) => {
            this.toggleStatusPAC = false;
            this.action = 'toggleStatusPAC';
            this.$store.dispatch('notifications/show', {
              message: response.data.message,
              type: response.data.type,
            });
            this.dialogStatusPAC = false;
            this.getDataFromApi()
            .then((data) => {
              this.items = data.items;
              this.totalItems = data.total;
            });
          });
      },
    },
  };

</script>
